"use strict";
module.exports = require('../../module.compiled').vendored['react-ssr'].ReactDOM;

//# sourceMappingURL=react-dom.js.map